import { render, staticRenderFns } from "./ListBnCmdArchiv.vue?vue&type=template&id=5e487140&scoped=true&"
import script from "./ListBnCmdArchiv.vue?vue&type=script&lang=js&"
export * from "./ListBnCmdArchiv.vue?vue&type=script&lang=js&"
import style0 from "./ListBnCmdArchiv.vue?vue&type=style&index=0&id=5e487140&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e487140",
  null
  
)

export default component.exports